import styled from 'styled-components';
import { useLocation } from 'react-router-dom';

import Menu from './Menu';
import pageMenu from 'constants/pageMenu';

const Container = styled.div`
  width: 100%;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const PAGE_MENUS = Object.values(pageMenu);

const Menus = () => {
  const { pathname } = useLocation();

  return (
    <Container>
      {PAGE_MENUS.map((menu) => (
        <Menu
          key={`sideBar/menu/${menu.to}/${menu.name}`}
          to={menu.to}
          name={menu.name}
          isSelected={pathname === menu.to}
          Icon={menu.Icon}
        />
      ))}
    </Container>
  );
};

export default Menus;
